import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-left-navigation',
  template: `
  <div id="leftnavlinks">
    <ul>
      <li><a [routerLink]="['barc']"><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Home</a></li>
      <li *ngIf="!isAdmin"><a [routerLink]="['login']"><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Login</a></li>
      <li *ngIf="isAdmin"><a routerLink='/admin'><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Admin Home</a></li>
      <li *ngIf="isAdmin"><a routerLink="/admin/sites"><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Site Manager</a></li>
      <li *ngIf="isAdmin"><a routerLink='/admin/documents'><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Document Manager</a></li>
      <li *ngIf="isAdmin"><a routerLink='/admin/document'><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Add Document</a></li>
      <li *ngIf="isAdmin && !isSuperAdmin"><a routerLink='/core/admin'><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Manage Users</a></li>
      <li *ngIf="isSuperAdmin"><a routerLink='/core/admin'><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Manage Users and Lists</a></li>
      <li *ngIf="isAdmin"><a (click)="logOut.emit()"><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Logout</a></li>
      <li>
        <div id='browseby'><div style="padding:4px 5px;color:#ccc;">BARC Search</div></div>
      </li>
      <li>
        <a [routerLink]="['/mapsearch']"><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Map Search</a>
      </li>
      <li>
        <a [routerLink]="['/advancedsearch']">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Advanced Search
        </a>
      </li>
      <li>
        <div id='browseby'><div style="padding:4px 5px;color:#ccc;">Glenn Dale</div></div>
      </li>
      <li>
        <a [routerLink]="['/glenndale']"><img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Home</a>
      </li>
      <li>
        <div id='browseby'><div style="padding:4px 5px;color:#ccc;">More Information</div></div>
      </li>
      <li>
        <a href='https://www.ars.usda.gov/northeast-area/' target="_blank">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> About BARC
        </a>
      </li>
      <li>
        <a href='https://www.ars.usda.gov/about-ars/' target="_blank">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> About ARS
        </a>
      </li>
      <li>
        <a href='https://www.ars.usda.gov/research/programs-projects/?modeCode=80-00-00-00' target="_blank">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Research
        </a>
      </li>
      <li>
        <a href='https://www.ars.usda.gov/people-locations/people-list/?modeCode=80-00-00-00' target="_blank">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> People & Places
        </a>
      </li>
      <li>
        <a href='https://www.epa.gov/superfund' target="_blank">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> About Superfund
        </a>
      </li>
      <li>
        <a href='https://www.ars.usda.gov/northeast-area/docs/cerclasuperfund/' target="_blank">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> About CERCLA
        </a>
      </li>
      <li>
        <a [routerLink]="['/aboutus']">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> About IR/AR
        </a>
      </li>
      <li>
        <a [routerLink]="['/contactus']">
          <img src='../images/quick_links_arrow.gif' alt='0' border='0' /> Contact Us
        </a>
      </li>
    </ul>
  </div>
  `
})
export class LeftNavigationComponent {
  @Input() isAdmin: boolean;
  @Input() isSuperAdmin: boolean;
  @Output() logOut: EventEmitter<any> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/left-navigation.ts